import {
  init,
  Event,
  Severity,
  withScope,
  captureException,
} from '@sentry/browser';

const DSN = 'https://f1d4c54bed3f4619a3c79d081d6d7ced@sentry.io/231405';

const sampleRate = 0.1;

const ignoreErrors = [/Loading chunk .* failed/, /Loading CSS chunk .* failed/];

const whitelistUrls = [
  /artists\.spotify\.com/, // production
  /ccra\.scdn\.co/, // cdn
];

export function beforeSend(event: Event) {
  // sample non-fatal errors
  if (event.level !== Severity.Fatal && Math.random() > sampleRate) {
    return null;
  }

  return event;
}

export function initializeSentry() {
  if (process.env.NODE_ENV === 'production') {
    init({
      dsn: DSN,
      release: process.env.REACT_APP_HASH,
      beforeSend,
      whitelistUrls,
      ignoreErrors,
    });
  }
}

export function createLogger(name = 'javascript') {
  return function logger(error: Error) {
    withScope(scope => {
      scope.setTag('logger', name);
      captureException(error);
    });
  };
}

export const logError = createLogger();
